

// import { useLocation } from 'react-router-dom';
// import { useRef, useEffect, useState } from 'react';
// import html2pdf from 'html2pdf.js';
// import { FaSms, FaWhatsapp } from 'react-icons/fa';
// import './billpdformat.css';
// import { useNavigate } from "react-router-dom";

// function formatDate(inputDate) {
//   if (!inputDate) return '';
//   const [year, month, day] = inputDate.split('-');
//   return `${day}-${month}-${year}`;
// }

// function getMonthName(dateStr) {
//   if (!dateStr) return '';
//   return new Date(dateStr).toLocaleString('default', { month: 'long' });
// }

// function getBillValue(tare, water, stick = 0) {
//   if (water > 0 && stick === 0) return `${tare} Kg , water:${water}`;
//   if (water === 0 && stick > 0) return `${tare} Kg , stick:${stick}`;
//   if (water > 0 && stick > 0) return `${tare} Kg , water:${water}kg , stick:${stick}`;
//   return `${tare} Kg`;
// }

// /* ===== Component ===== */
// function BillPagepdf() {
//   const location = useLocation();
//   const billRef = useRef();

//   const [monthlyTotalQty, setMonthlyTotalQty] = useState(0);
//   const [previewSMS, setPreviewSMS] = useState(null);
//   const [showPreview, setShowPreview] = useState(false);
//   const navigate = useNavigate();

//   const billData = location.state || {};
//   const {
//     name,
//     ph,
//     date,
//     time,
//     qtyList = [],
//     tare = 8,
//     water = 0,
//     stick = 0,
//     netweight = 0,
//     farmid,
//     billno
//   } = billData;

//   /* ===== Monthly Total ===== */
//   useEffect(() => {
//     if (!farmid || !date) return;

//     const cleanFarmId = String(farmid).trim();
//     const selectedMonth = date.slice(0, 7);

//     fetch('https://kmtea.onrender.com/collecttea')
//       .then(res => res.json())
//       .then(data => {
//         const filtered = data.filter(
//           d => d.farmid === cleanFarmId && d.date.slice(0, 7) === selectedMonth
//         );
//         const total = filtered.reduce((s, i) => s + (i.netweight || 0), 0);
//         setMonthlyTotalQty(total);
//       })
//       .catch(err => console.error(err));
//   }, [farmid, date]);

//   /* ===== PDF ===== */
//   const handleDownload = () => {
//     html2pdf().from(billRef.current).save(`Tea_Bill_${name}_${date}.pdf`);
//   };

//   return (
//     <div className="thermal-bill-wrapper">
//       <div className="thermal-bill-format thermal-modern-card" ref={billRef}>
//         <div className="thermal-bill-header thermal-modern-header">
//           <p>பதிவு எண் : SRG/Ooty/15/2024</p>
//           <h2>ஸ்ரீ கன்னிமாரியம்மன் சிறு தேயிலை விவசாயிகள் நல சங்கம்</h2>
//           <p>"கம்மந்து"</p>
//         </div>

//         <div className="thermal-bill-info thermal-modern-info">
//           <p><strong>No:</strong> {billno || '---'}</p>
//           <p><strong>Name:</strong> {name}, {ph}</p>
//           <p><strong>Date :</strong> {formatDate(date)}, {time}</p>
//         </div>

//         <table className="thermal-modern-table">
//           <thead>
//             <tr>
//               <th>Bag No</th>
//               <th>Qty (kg)</th>
//               <th>Water (kg)</th>
//               <th>Tare (kg)</th>
//               <th>Net Weight (kg)</th>
//             </tr>
//           </thead>

//           <tbody>
//             {qtyList.map((qty, index) => (
//               <tr key={index}>
//                 <td>{index + 1}</td>
//                 <td>{qty}</td>

//                 {index === 0 && (
//                   <>
//                     <td rowSpan={qtyList.length} className="thermal-rowspan-cell">
//                       {water}
//                     </td>
//                     <td rowSpan={qtyList.length} className="thermal-rowspan-cell">
//                       {tare}
//                     </td>
//                     <td rowSpan={qtyList.length} className="thermal-rowspan-cell">
//                       {netweight}
//                     </td>
//                   </>
//                 )}
//               </tr>
//             ))}

//             <tr className="thermal-total-row">
//               <td><strong>Total</strong></td>
//               <td></td>
//               <td><strong>{water}</strong></td>
//               <td><strong>{tare}</strong></td>
//               <td><strong>{netweight}</strong></td>
//             </tr>
//           </tbody>
//         </table>

//         <h4 className='gtotal' >Grand Total ({getMonthName(date)}): {monthlyTotalQty} kg</h4>
//       </div>

//       <div className="thermal-button-group">
//         <button onClick={handleDownload}>Download</button>
//       </div>
//     </div>
//   );
// }

// export default BillPagepdf;

import { useLocation } from 'react-router-dom';
import { useRef, useEffect, useState } from 'react';
import html2pdf from 'html2pdf.js';
import './billpdformat.css';

function formatDate(inputDate) {
  if (!inputDate) return '';
  const [year, month, day] = inputDate.split('-');
  return `${day}-${month}-${year}`;
}

function getMonthName(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString('default', { month: 'long' });
}

function BillPagepdf() {
  const location = useLocation();
  const billRef = useRef();

  const [monthlyTotalQty, setMonthlyTotalQty] = useState(0);

  const billData = location.state || {};
  const {
    name,
    ph,
    date,
    time,
    qtyList = [],
    tare = 8,
    water = 0,
    netweight = 0,
    farmid,
    billno
  } = billData;

  /* ===== Monthly Total ===== */
  useEffect(() => {
    if (!farmid || !date) return;

    const selectedMonth = date.slice(0, 7);

    fetch('https://kmtea.onrender.com/collecttea')
      .then(res => res.json())
      .then(data => {
        const filtered = data.filter(
          d => d.farmid === farmid && d.date.slice(0, 7) === selectedMonth
        );
        const total = filtered.reduce((s, i) => s + (i.netweight || 0), 0);
        setMonthlyTotalQty(total);
      });
  }, [farmid, date]);

  /* ===== 🔥 A4 WIDTH + AUTO HEIGHT PDF ===== */
  const handleDownload = () => {
    const element = billRef.current;

    const a4WidthPx = 794; // ✅ A4 WIDTH (fixed)
    const contentHeightPx = element.scrollHeight; // ✅ AUTO HEIGHT

    const opt = {
      margin: 0,
      filename: `Tea_Bill_${name}_${date}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        scrollY: 0,
      },
      jsPDF: {
        unit: 'px',
        format: [a4WidthPx, contentHeightPx], // 🔥 ONLY HEIGHT CHANGES
        orientation: 'portrait',
      },
      pagebreak: { mode: ['avoid-all'] } // ❌ No page split
    };

    html2pdf().set(opt).from(element).save();
  };

  return (
    <div className="thermal-bill-wrapper">
      <div className="thermal-bill-format thermal-modern-card" ref={billRef}>

        <div className="thermal-bill-header thermal-modern-header">
          <p>பதிவு எண் : SRG/Ooty/15/2024</p>
          <h2>ஸ்ரீ கன்னிமாரியம்மன் சிறு தேயிலை விவசாயிகள் நல சங்கம்</h2>
          <p>"கம்மந்து"</p>
        </div>

        <div className="thermal-bill-info thermal-modern-info">
          <p>No : {billno || '---'}</p>
          <p>Name : {name}, {ph}</p>
          <p>Date : {formatDate(date)}, {time}</p>
        </div>

        <table className="thermal-modern-table">
          <thead>
            <tr>
              <th>Bag No</th>
              <th>Qty (kg)</th>
              <th>Water (kg)</th>
              <th>Tare (kg)</th>
              <th>Net Weight (kg)</th>
            </tr>
          </thead>

          <tbody>
            {qtyList.map((qty, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{qty}</td>

                {index === 0 && (
                  <>
                    <td rowSpan={qtyList.length} className="thermal-rowspan-cell">{water}</td>
                    <td rowSpan={qtyList.length} className="thermal-rowspan-cell">{tare}</td>
                    <td rowSpan={qtyList.length} className="thermal-rowspan-cell">{netweight}</td>
                  </>
                )}
              </tr>
            ))}

            <tr className="thermal-total-row">
              <td><strong>Total</strong></td>
              <td></td>
              <td><strong>{water}</strong></td>
              <td><strong>{tare}</strong></td>
              <td><strong>{netweight}</strong></td>
            </tr>
          </tbody>
        </table>

        <h4 className="gtotal">
          Grand Total ({getMonthName(date)}): {monthlyTotalQty} kg
        </h4>

      </div>

      <div className="thermal-button-group">
        <button onClick={handleDownload}>Download</button>
      </div>
    </div>
  );
}

export default BillPagepdf;
